module.exports = __webpack_public_path__ + "img/WP2023-Icon-Networking.93636077.svg";